"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sizes = void 0;
var react_jss_1 = require("react-jss");
var theme_1 = require("../../../mantine-theme/src");
exports.sizes = {
    xs: 16,
    sm: 26,
    md: 38,
    lg: 56,
    xl: 84,
};
exports.default = react_jss_1.createUseStyles({
    avatar: function (_a) {
        var size = _a.size, radius = _a.radius, theme = _a.theme;
        return ({
            boxSizing: 'border-box',
            position: 'relative',
            userSelect: 'none',
            overflow: 'hidden',
            width: theme_1.getSizeValue({ size: size, sizes: exports.sizes }),
            height: theme_1.getSizeValue({ size: size, sizes: exports.sizes }),
            borderRadius: radius ? theme_1.getSizeValue({ size: radius, sizes: theme.radius }) : size,
        });
    },
    image: {
        objectFit: 'cover',
        width: '100%',
        height: '100%',
    },
    placeholder: function (_a) {
        var theme = _a.theme, size = _a.size, color = _a.color;
        return (__assign(__assign({}, theme_1.getFontStyles(theme)), { fontSize: theme_1.getSizeValue({ size: size, sizes: exports.sizes }) / 2.5, color: theme_1.getThemeColor({ theme: theme, color: color, shade: theme.colorScheme === 'dark' ? 0 : 6 }), fontWeight: 700, backgroundColor: theme_1.getThemeColor({ theme: theme, color: color, shade: theme.colorScheme === 'dark' ? 9 : 1 }), display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%', userSelect: 'none' }));
    },
    placeholderIcon: function (_a) {
        var theme = _a.theme, color = _a.color;
        return ({
            width: '70%',
            height: '70%',
            color: theme_1.getThemeColor({ theme: theme, color: color, shade: theme.colorScheme === 'dark' ? 0 : 6 }),
        });
    },
}, { link: true });
